import { render, staticRenderFns } from "./detailsOrderB2b.vue?vue&type=template&id=5a33e8b7&"
import script from "./detailsOrderB2b.vue?vue&type=script&lang=js&"
export * from "./detailsOrderB2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports